/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentEventLogNextEvent: "shipment-event-log-next-event",
} as const;
